import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBj_Fa1M2sOk1zrVCT2VN33zFFvd_OEQx4",
  authDomain: "lifetrackr-6086c.firebaseapp.com",
  projectId: "lifetrackr-6086c",
  storageBucket: "lifetrackr-6086c.firebasestorage.app",
  messagingSenderId: "183928205089",
  appId: "1:183928205089:web:b58a89db94ed7963935860",
  measurementId: "G-8Q5SG0W4PF"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
